import enviro from 'enviro';
import { List } from 'immutable';
import { useEffect, useState } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
// @ts-expect-error ts-migrate(2792) FIXME: Cannot find module 'SafeStorage'. Did you mean to ... Remove this comment to see the full error message
import SafeStorage from 'SafeStorage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Box } from 'foundations-components/transitional/components/Box';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
const SELENIUM_DISABLE_BANNERS_KEY = 'selenium.disable.banners';
function shouldDisableBannersForSelenium() {
  try {
    return SafeStorage.getItem(SELENIUM_DISABLE_BANNERS_KEY) === 'true';
  } catch (e) {
    console.error('Call to SafeStorage threw', e);
    return false;
  }
}
const replaceStr = (string, ...placeholders) => {
  let count = 0;
  return string.replace(/%s/g, () => placeholders[count++]);
};
const PropTypeBanner = () => {
  const [errors, setErrors] = useState(List());
  const [hideAlert, setHideAlert] = useState(false);
  const isDeployed = enviro.deployed();
  const disableBannersForSelenium = shouldDisableBannersForSelenium();
  useEffect(() => {
    // do not show on qa, prod, selenium tests, or in iframes
    if (isDeployed || disableBannersForSelenium || window.parent !== window) {
      return emptyFunction;
    }
    const originalConsoleError = window.console.error;
    window.console.error = (...args) => {
      const message = args[0];
      if (`${message}`.indexOf('Failed %s type') !== -1) {
        setTimeout(() => setErrors(existingErrors =>
        // @ts-expect-error ts-migrate(2556) FIXME: A spread argument must either have a tuple type or... Remove this comment to see the full error message
        existingErrors.push(replaceStr(...args))));
      } else if (`${message}`.indexOf('Failed prop type:') !== -1) {
        setTimeout(() => setErrors(existingErrors =>
        // @ts-expect-error ts-migrate(2556) FIXME: A spread argument must either have a tuple type or... Remove this comment to see the full error message
        existingErrors.push(replaceStr(...args))));
      }
      originalConsoleError(...args);
    };
    return function cleanup() {
      window.console.error = originalConsoleError;
    };
  });
  if (isDeployed || errors.size === 0 || hideAlert || disableBannersForSelenium) {
    return null;
  }
  return /*#__PURE__*/_jsx(Box, {
    children: /*#__PURE__*/_jsx(Alert, {
      closeable: true,
      onClose: () => setHideAlert(true),
      titleText: `Help keep the console tidy! There's ${errors.size} prop type warning${errors.size > 1 ? 's' : ''}`,
      type: "danger",
      use: "inline",
      children: errors.map((message, index) => /*#__PURE__*/_jsx(TruncateString, {
        tooltip: false,
        children: message
      }, index))
    })
  });
};
export default PropTypeBanner;